
import october2020Minutes from '../images/LPGRA_Minutes_of_Meeting_Oct_1_2020.pdf';
import november2020Minutes from '../images/LPGRA_Minutes_November_5_2020.pdf';
import december2020Minutes from '../images/LPGRA_Minutes_December_3_2020.pdf';
import february2021Minutes from '../images/LPGRA_Minutes_February_4_2021.pdf';
import march2021Minutes from '../images/LPGRA_Minutes_March_4_2021.pdf';
import april2021Minutes from '../images/LPGRA_Minutes_April_1_2021.pdf';
import may2021Minutes from '../images/LPGRA_Minutes_May_6_2021.pdf';
import june2021Minutes from '../images/LPGRA_Minutes_June_3_2021.pdf';
import july2021Minutes from '../images/LPGRA_Minutes_July_1_2021.pdf';
import august2021Minutes from '../images/LPGRA_Minutes_August_5_2021.pdf';
import september2021Minutes from '../images/LPGRA_Minutes_Sept_2_2021.pdf';
import october2021Minutes from '../images/LPGRA_Minutes_October_7_2021.pdf';
import november2021MinutesSuppMap from '../images/Stop_Bars.pdf';
import november2021Minutes from '../images/LPGRA_Minutes_November_4_2021.pdf';
import december2021Minutes from '../images/LPGRA_Minutes_December_2_2021.pdf';
import january2022Minutes from '../images/LPGRA_Minutes_January_5_2022.pdf';
import february2022Minutes from '../images/LPGRA_Minutes_February_3_2022.pdf';
import march2022Minutes from '../images/LPGRA_Minutes_March_3_2022.pdf';
import april2022Minutes from '../images/LPGRA_Minutes_April_7_2022.pdf';
import may2022Minutes from '../images/LPGRA_Minutes_May_5_2022.pdf';
import june2022Minutes from '../images/LPGRA_Minutes_June_2_2022.pdf';
import july2022Minutes from '../images/LPGRA_Minutes_July_7_2022.pdf';
import august2022Minutes from '../images/LPGRA_Minutes_August_4_2022.pdf';
import september2022Minutes from '../images/LPGRA_Minutes_Sept_1_2022.pdf';
import october2022Minutes from '../images/LPGRA_Minutes_October_6_2022.pdf';
import november2022Minutes from '../images/LPGRA_Minutes_November_3_2022.pdf';
import december2022Minutes from '../images/LPGRA_Minutes_December_1_2022.pdf';
import january2023Minutes from '../images/LPGRA_Minutes_January_5_2023.pdf';
import february2023Minutes from '../images/LPGRA_Minutes_February_2023.pdf';
import march2023Minutes from '../images/LPGRA_Minutes_March_2_2023.pdf';
import april2023Minutes from '../images/LPGRA_Minutes_April_6_2023.pdf';
import may2023Minutes from '../images/LPGRA_Minutes_May_4_2023.pdf';
import june2023Minutes from '../images/LPGRA_Minutes_June_1_2023.pdf';
import july2023Minutes from '../images/LPGRA_Minutes_July_07_2023.pdf';
import august2023Minutes from '../images/LPGRA_Minutes_August_3_2023.pdf';
import september2023Minutes from '../images/LPGRA_Minutes_September_7_2023.pdf';
import october2023Minutes from '../images/LPGRA_Minutes_October_5_2023.pdf';
import november2023Minutes from '../images/LPGRA_Minutes_November_2_2023.pdf';
import december2023Minutes from '../images/LPGRA_Minutes_December_7_2023.pdf';
import january2024Minutes from '../images/LPGRA_Minutes_January_4_2024.pdf';
import february2024Minutes from '../images/LPGRA_Minutes_February_01_2024.pdf';
import march2024Minutes from '../images/LPGRA_Minutes_March_07_2024.pdf';
import april2024Minutes from '../images/LPGRA_Minutes_April_04_2024.pdf';
import may2024Minutes from '../images/LPGRA_Minutes_May_2_2024.pdf';
import june2024Minutes from '../images/LPGRA_Minutes_June_6_2024.pdf';
import july2024Minutes from '../images/LPGRA_Minutes_July_11_2024.pdf';
import august2024Minutes from '../images/LPGRA_Minutes_August_1_2024.pdf';
import september2024Minutes from '../images/LPGRA_Minutes_September_5_2024.pdf';
import october2024Minutes from '../images/LPGRA_Minutes_October_3_2024.pdf';
import november2024Minutes from '../images/LPGRA_Minutes_November_7_2024.pdf';
import december2024Minutes from '../images/LPGRA_Minutes_December_5_2024.pdf';
import january2025Minutes from '../images/LPGRA_Minutes_January_2_2025.pdf';
import february2025Minutes from '../images/LPGRA_Minutes_February_6_2025.pdf';
import march2025Minutes from '../images/LPGRA_Minutes_March_06_2025.pdf';
import april2025Minutes from '../images/LPGRA_Minutes_April_03_2025.pdf';
import may2025Minutes from '../images/LPGRA_Minutes_May_01_2025.pdf';
import june2025Minutes from '../images/LPGRA_Minutes_June_5_2025.pdf';
import july2025Minutes from '../images/LPGRA_Minutes_July_3_2025.pdf';
import august2025Minutes from '../images/LPGRA_Minutes_August_7_2025.pdf';
import september2025Minutes from '../images/LPGRA_Minutes_September_4_2025.pdf';
import october2025Minutes from '../images/LPGRA_Minutes_October_2_2025.pdf';
import november2025Minutes from '../images/LPGRA_Minutes_November_6_2025.pdf';
import december2025Minutes from '../images/LPGRA_Minutes_December_4_2025.pdf';
import january2026Minutes from '../images/LPGRA_Minutes_January_8_2026.pdf';
import february2026Minutes from '../images/LPGRA_Minutes_February_5_2026.pdf';
import march2026Minutes from '../images/LPGRA_Minutes_March_5_2026.pdf';
import april2026Minutes from '../images/LPGRA_Minutes_April_2_2026.pdf';
import may2026Minutes from '../images/LPGRA_Minutes_May_7_2026.pdf';
import june2026Minutes from '../images/LPGRA_Minutes_June_4_2026.pdf';

const MinutesPDFData = [
    {
        id: '10-2020',
        path: october2020Minutes,
        date: 'October 2020'
    },
    {
        id: '11-2020',
        path: november2020Minutes,
        date: 'November 2020'
    },
    {
        id: '12-2020',
        path: december2020Minutes,
        date: 'December 2020'
    },
    {
        id: '02-2021',
        path: february2021Minutes,
        date: 'February 2021'
    },
    {
        id: '03-2021',
        path: march2021Minutes,
        date: 'March 2021'
    },
    {
        id: '04-2021',
        path: april2021Minutes,
        date: 'April 2021'
    },
    {
        id: '05-2021',
        path: may2021Minutes,
        date: 'May 2021'
    },
    {
        id: '06-2021',
        path: june2021Minutes,
        date: 'June 2021'
    },
    {
        id: '07-2021',
        path: july2021Minutes,
        date: 'July 2021'
    },
    {
        id: '08-2021',
        path: august2021Minutes,
        date: 'August 2021'
    },
    {
        id: '09-2021',
        path: september2021Minutes,
        date: 'September 2021'
    },
    {
        id: '10-2021',
        path: october2021Minutes,
        date: 'October 2021'
    },
    {
        id: '11-2021-a',
        path: november2021MinutesSuppMap,
        date: 'November 2021 - Supplemental Map'
    },
    {
        id: '11-2021',
        path: november2021Minutes,
        date: 'November 2021'
    },
    {
        id: '12-2021',
        path: december2021Minutes,
        date: 'December 2021'
    },
    {
        id: '01-2022',
        path: january2022Minutes,
        date: 'January 2022'
    },
    {
        id: '02-2022',
        path: february2022Minutes,
        date: 'February 2022'
    },
    {
        id: '03-2022',
        path: march2022Minutes,
        date: 'March 2022'
    },
    {
        id: '04-2022',
        path: april2022Minutes,
        date: 'April 2022'
    },
    {
        id: '05-2022',
        path: may2022Minutes,
        date: 'May 2022'
    },
    {
        id: '06-2022',
        path: june2022Minutes,
        date: 'June 2022'
    },
    {
        id: '07-2022',
        path: july2022Minutes,
        date: 'July 2022'
    },
    {
        id: '08-2022',
        path: august2022Minutes,
        date: 'August 2022'
    },
    {
        id: '09-2022',
        path: september2022Minutes,
        date: 'September 2022'
    },
    {
        id: '10-2022',
        path: october2022Minutes,
        date: 'October 2022'
    },
    {
        id: '11-2022',
        path: november2022Minutes,
        date: 'November 2022'
    },
    {
        id: '12-2022',
        path: december2022Minutes,
        date: 'December 2022'
    },
    {
        id: '01-2023',
        path: january2023Minutes,
        date: 'January 2023'
    },
    {
        id: '02-2023',
        path: february2023Minutes,
        date: 'February 2023'
    },
    {
        id: '03-2023',
        path: march2023Minutes,
        date: 'March 2023'
    },
    {
        id: '04-2023',
        path: april2023Minutes,
        date: 'April 2023'
    },
    {
        id: '05-2023',
        path: may2023Minutes,
        date: 'May 2023'
    },
    {
        id: '06-2023',
        path: june2023Minutes,
        date: 'June 2023'
    },
    {
        id: '07-2023',
        path: july2023Minutes,
        date: 'July 2023'
    },
    {
        id: '08-2023',
        path: august2023Minutes,
        date: 'August 2023'
    },
    {
        id: '09-2023',
        path: september2023Minutes,
        date: 'September 2023'
    },
    {
        id: '10-2023',
        path: october2023Minutes,
        date: 'October 2023'
    },
    {
        id: '11-2023',
        path: november2023Minutes,
        date: 'November 2023'
    },
    {
        id: '12-2023',
        path: december2023Minutes,
        date: 'December 2023'
    },
    {
        id: '01-2024',
        path: january2024Minutes,
        date: 'January 2024'
    },
    {
        id: '02-2024',
        path: february2024Minutes,
        date: 'February 2024'
    },
    {
        id: '03-2024',
        path: march2024Minutes,
        date: 'March 2024'
    },
    {
        id: '04-2024',
        path: april2024Minutes,
        date: 'April 2024'
    },
    {
        id: '05-2024',
        path: may2024Minutes,
        date: 'May 2024'
    },
    {
        id: '06-2024',
        path: june2024Minutes,
        date: 'June 2024'
    },
    {
        id: '07-2024',
        path: july2024Minutes,
        date: 'July 2024'
    },
    {
        id: '08-2024',
        path: august2024Minutes,
        date: 'August 2024'
    },
    {
        id: '09-2024',
        path: september2024Minutes,
        date: 'September 2024'
    },
    {
        id: '10-2024',
        path: october2024Minutes,
        date: 'October 2024'
    },
    {
        id: '11-2024',
        path: november2024Minutes,
        date: 'November 2024'
    },
    {
        id: '12-2024',
        path: december2024Minutes,
        date: 'December 2024'
    },
    {
        id: '01-2025',
        path: january2025Minutes,
        date: 'January 2025'
    },
    {
        id: '02-2025',
        path: february2025Minutes,
        date: 'February 2025'
    },
    {
        id: '03-2025',
        path: march2025Minutes,
        date: 'March 2025'
    },
    {
        id: '04-2025',
        path: april2025Minutes,
        date: 'April 2025'
    },
    {
        id: '05-2025',
        path: may2025Minutes,
        date: 'May 2025'
    },
    {
        id: '06-2025',
        path: june2025Minutes,
        date: 'June 2025'
    },
    {
        id: '07-2025',
        path: july2025Minutes,
        date: 'July 2025'
    },
    {
        id: '08-2025',
        path: august2025Minutes,
        date: 'August 2025'
    },
    {
        id: '09-2025',
        path: september2025Minutes,
        date: 'September 2025'
    },
    {
        id: '10-2025',
        path: october2025Minutes,
        date: 'October 2025'
    },
    {
        id: '11-2025',
        path: november2025Minutes,
        date: 'November 2025'
    },
    {
        id: '12-2025',
        path: december2025Minutes,
        date: 'December 2025'
    },
    {
        id: '01-2026',
        path: january2026Minutes,
        date: 'January 2026'
    },
    {
        id: '02-2026',
        path: february2026Minutes,
        date: 'February 2026'
    },
    {
        id: '03-2026',
        path: march2026Minutes,
        date: 'March 2026'
    },
    {
        id: '04-2026',
        path: april2026Minutes,
        date: 'April 2026'
    },
    {
        id: '05-2026',
        path: may2026Minutes,
        date: 'May 2026'
    },
    {
        id: '06-2026',
        path: june2026Minutes,
        date: 'June 2026'
    },
]

export default MinutesPDFData;